/*
 * vrtContact.ts
 * vue router: Contact Admin
 * Note: Public contact form is now at /public/contact (see vrtPublic.ts)
 */
import type { RouteRecordRaw } from 'vue-router';

// Admin route with authentication
const vrtContactAdmin: RouteRecordRaw = {
  path: '/eservices/contactus',
  name: 'vrtContactAdmin',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    {
      path: 'list',
      name: 'vrtContactAdminList',
      component: () => import('./vpgContactAdminList.vue'),
    },
  ],
};

export default vrtContactAdmin;
export { vrtContactAdmin };
